import Vue from 'vue'

import AppToast from '@/components/ui/AppToast.vue'

const DEFAULT_POSITION = 'top-right'
const DEFAULT_ERROR_MESSAGE = 'Произошла неизвестная ошибка.'

const formatError = error => {
    const responseData = error?.response?.data
    const responseError = responseData?.error
    const message =
        (typeof responseError === 'string' && responseError) ||
        responseError?.message ||
        responseData?.message ||
        error?.message ||
        (typeof error === 'string' && error) ||
        DEFAULT_ERROR_MESSAGE
    const code = responseData?.code ?? responseData?.error_code ?? error?.code

    return code === undefined || code === null
        ? message
        : `${message} (код ${code})`
}

const showToast = ({
    text,
    title = null,
    variant = 'info',
    position,
    component = AppToast,
    props = {},
    listeners,
    options = {},
}) => {
    if (!text && !title && component === AppToast && !props.text && !props.title)
        return

    const resolvedPosition = position || DEFAULT_POSITION

    const payload = {
        component,
        props: {
            title,
            text,
            variant,
            ...props,
        },
    }

    if (listeners) {
        payload.listeners = listeners
    }

    const baseOptions = {
        toastClassName: 'app-common-notification',
        position: resolvedPosition,
    }

    const mergedOptions = {
        ...baseOptions,
        ...options,
    }

    mergedOptions.toastClassName = [
        baseOptions.toastClassName,
        options.toastClassName,
    ]
        .filter(Boolean)
        .join(' ')
        .trim()

    Vue.prototype.$toast(payload, mergedOptions)
}

export const notificationService = {
    showSuccess(text, title = null, options = {}) {
        const { props, ...toastOptions } = options
        showToast({
            text,
            title,
            variant: 'success',
            props,
            options: toastOptions,
        })
    },

    showError(error, title = null, options = {}) {
        const { props, ...toastOptions } = options
        showToast({
            text: formatError(error),
            title,
            variant: 'error',
            props,
            options: toastOptions,
        })
    },

    showMessage(text, title = null, options = {}) {
        const variant = options.variant || 'info'
        const { props, ...toastOptions } = options
        showToast({ text, title, variant, props, options: toastOptions })
    },

    showWarning(text, title = null, options = {}) {
        const { props, ...toastOptions } = options
        showToast({
            text,
            title,
            variant: 'warning',
            props,
            options: toastOptions,
        })
    },
}

export const showCustomNotification = showToast
